import React from 'react'

const IconShapeRect = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <rect x='4' y='6' width='16' height='12' rx='1.5' />
      </svg>
   )
}
export default IconShapeRect
